import { withChartLayout } from 'components/common';
import Immunizations from 'components/features/chart/admission-history/immunizations/Immunizations';

const ImmunizationsPage = withChartLayout('Immunizations')(Immunizations);
export default ImmunizationsPage;
